type asyncFunction = () => Promise<unknown>;
type Data = unknown | null;
type customError = Error | null;
type Result = Promise<[Data, customError]>;

export const tryCatchAsyncWrapper = async (asyncFunc: asyncFunction): Result => {
  try {
    const data = await asyncFunc();
    return [data, null];
  } catch (error) {
    return [null, error as Error];
  }
};
